import React, { useState } from "react";
import { Button, Modal, List } from "antd";
import { EyeOutlined } from "@ant-design/icons";

const Simple = () => {
  const [optionsModalVisible, setOptionsModalVisible] = useState(false);
  const [detailsModalVisible, setDetailsModalVisible] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);

  const items = [
    { id: 1, name: "Item 1" },
    { id: 2, name: "Item 2" },
    { id: 3, name: "Item 3" },
  ];

  const showOptionsModal = (item) => {
    setSelectedItem(item);
    setOptionsModalVisible(true);
  };

  const handleSelectOption = (option) => {
    setSelectedOption(option);
    setOptionsModalVisible(false);
    setDetailsModalVisible(true);
  };

  const handleCloseDetailsModal = () => {
    setDetailsModalVisible(false);
    setSelectedOption(null);
  };

  const OptionsModal = ({ visible, onClose, onSelectOption }) => (
    <Modal
      title="Select an Option"
      visible={visible}
      onCancel={onClose}
      footer={null}
    >
      <Button
        onClick={() => onSelectOption("orange")}
        style={{ marginRight: "10px" }}
      >
        Orange
      </Button>
      <Button onClick={() => onSelectOption("green")}>Green</Button>
    </Modal>
  );

  return (
    <div>
      <List
        itemLayout="horizontal"
        dataSource={items}
        renderItem={(item) => (
          <List.Item
            actions={[
              <Button
                icon={<EyeOutlined />}
                onClick={() => showOptionsModal(item)}
              />,
            ]}
          >
            <List.Item.Meta title={item.name} />
          </List.Item>
        )}
      />

      <OptionsModal
        visible={optionsModalVisible}
        onClose={() => setOptionsModalVisible(false)}
        onSelectOption={handleSelectOption}
      />

      <Modal
        title={`Details for ${selectedItem?.name}`}
        visible={detailsModalVisible}
        onCancel={handleCloseDetailsModal}
        footer={null}
      >
        {selectedOption === "orange" && <p>Orange is beautiful</p>}
        {selectedOption === "green" && <p>Green is ugly</p>}
      </Modal>
    </div>
  );
};

export default Simple;
